// extracted by mini-css-extract-plugin
export default {"BodyParagraph":"_BodyParagraph--mVQph","BodyParagraphRedTop":"_BodyParagraphRedTop--kOMrX","BodyParagraphRedBottom":"_BodyParagraphRedBottom--_RgOr"};